<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container">
        <a class="navbar-brand" routerLink="/">
            <img width="100" src="assets/img/logos/leybic.svg" alt="Ley BIC">
            <img width="100" src="assets/img/logos/leybic.svg" alt="Ley BIC">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item"><a class="nav-link" href="#home">Home</a></li>
                <li class="nav-item"><a class="nav-link" href="#about">Ley BIC</a></li>
                <li class="nav-item"><a class="nav-link" href="#prensa">Prensa</a></li>
                <li class="nav-item"><a class="nav-link" href="#documents">Documentos</a></li>
                <li class="nav-item"><a class="nav-link" href="#faq">Preguntas Frecuentes</a></li>
                <li class="nav-item"><a class="nav-link" href="#contact">Contacto</a></li>
            </ul>
        </div>
    </div>
</nav>